import { StoreConfig } from '@fingertip/creator-proto/gen/fingertip/common/type/v1/store_config_pb'
import { GetStoreCouponPublicResponse } from '@fingertip/creator-proto/gen/fingertip/creator/store_coupon/v1/store_coupon_pb'
import { GetStripeBookingPaymentAmountPublicResponse } from '@fingertip/creator-proto/gen/fingertip/creator/store_payment/v1/store_payment_pb'
import { observer } from 'mobx-react-lite'
import { useTranslation } from 'react-i18next'

import { BookerCouponForm } from '@/components/booking/booker/components/booker-coupon-form'
import { Separator } from '@/components/ui/separator'
import { formatPriceInCents } from '@/lib/dinero/utils'
import { BookingSelection } from '@/lib/hooks/use-booking-selection'

type Props = {
  form: any
  siteSlug: string
  storeConfig?: StoreConfig
  bookingSelection: BookingSelection
  bookingPayment?: GetStripeBookingPaymentAmountPublicResponse
  bookingCoupon?: GetStoreCouponPublicResponse
}

export const BookerPaymentSummary = observer(
  ({ form, siteSlug, storeConfig, bookingPayment, bookingCoupon }: Props) => {
    const { t } = useTranslation()

    return (
      <div className="flex flex-col mt-4">
        <div className="flex justify-between">
          <span>{t('subtotal')}</span>
          <div>
            <span>
              {formatPriceInCents(
                bookingPayment?.subtotalAmountInCents || 0,
                storeConfig?.currency || 'usd',
                false,
                true,
              )}
            </span>
          </div>
        </div>

        {!!bookingPayment && bookingPayment?.discountAmountInCents > 0 && (
          <div className="mt-2 flex justify-between">
            <div>{t('discounts')}</div>
            <span>
              -
              {formatPriceInCents(
                bookingPayment?.discountAmountInCents || 0,
                storeConfig?.currency || 'usd',
                false,
                true,
              )}
            </span>
          </div>
        )}

        <Separator className="my-2" />

        <div className="mt-2 flex justify-between font-semibold">
          <div>{t('total')}</div>
          <span>
            {formatPriceInCents(
              bookingPayment?.totalAmountInCents || 0,
              storeConfig?.currency || 'usd',
              false,
              true,
            )}
          </span>
        </div>

        {!!bookingPayment && bookingPayment?.depositAmountInCents > 0 && (
          <div className="mt-2 flex justify-between">
            <div>{t('pay_now')}</div>
            <span>
              {formatPriceInCents(
                bookingPayment?.depositAmountInCents || 0,
                storeConfig?.currency || 'usd',
                false,
                true,
              )}
            </span>
          </div>
        )}

        <div className="mt-4 flex flex-row justify-end">
          <BookerCouponForm
            form={form}
            siteSlug={siteSlug}
            coupon={bookingCoupon?.coupon}
          />
        </div>
      </div>
    )
  },
)
